import {
  Component, Input, OnInit,
} from '@angular/core';
import { RouterService } from './router.service';

@Component({
  selector: 'ba-router',
  template: '<ng-content></ng-content>',
})
export class RouterComponent implements OnInit {
  @Input() init?: string;

  constructor(
    private readonly router: RouterService,
  ) { }

  ngOnInit(): void {
    if (this.init) {
      this.router.navigate(this.init);
    }
  }
}
